module.exports = __webpack_public_path__ + "img/inl.c7c2e012.png";